/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { ReactNode } from "react";
import { useClientVersionChecker } from "../../hooks/useClientVersionChecker";

type ClientVersionCheckerProps = {
  children: ReactNode
}

export default function ClientVersionChecker({ children }:ClientVersionCheckerProps) {
  useClientVersionChecker();

  return <>{children}</>
}
